export default __webpack_public_path__ + "static/media/unreleased6.a6f8960b.svg";